/**
 * Страницы `/ru` и `/uk`. Источник — `index.html` (EN): каждая строка заменяется целиком, и если её там нет, сборка падает,
 * чтобы правка английского текста не оставила на странице языка английский кусок.
 */
type PageStrings = ReadonlyArray<readonly [en: string, localized: string]>;

/** Заголовок и описание страницы языка: те же строки клиент ставит при смене языка без перезагрузки. */
export const PAGE_META = {
  en: {
    title: "Zombie Defense Game: Play Free Online — New Fun Game",
    description:
      "Hold the base against waves of zombies, level up your heroes and take down bosses. Free in your browser or Telegram, nothing to install, phone or PC.",
  },
  ru: {
    title: "Зомби-оборона: играть онлайн бесплатно — New Fun Game",
    description:
      "Держите штаб против волн зомби, качайте героев и валите боссов. Бесплатно в браузере или в Telegram, ничего ставить не надо, на телефоне и компьютере.",
  },
  uk: {
    title: "Зомбі-оборона: грати онлайн безкоштовно — New Fun Game",
    description:
      "Тримайте штаб проти хвиль зомбі, качайте героїв і трощіть босів. Безкоштовно в браузері чи Telegram, нічого встановлювати не треба, на телефоні й ПК.",
  },
} as const;

const RU_PAGE: PageStrings = [
  ['<html lang="en">', '<html lang="ru">'],
  [PAGE_META.en.title, PAGE_META.ru.title],
  [PAGE_META.en.description, PAGE_META.ru.description],
  ['rel="canonical" href="https://newfungame.com/"', 'rel="canonical" href="https://newfungame.com/ru"'],
  ['property="og:url" content="https://newfungame.com/"', 'property="og:url" content="https://newfungame.com/ru"'],
  ['property="og:locale" content="en_US"', 'property="og:locale" content="ru_RU"'],
  ["Zombie defense game: hold the base", "Зомби-оборона: удержи штаб"],
  [
    `Zombies come at your base from every side, wave after wave. Your heroes shoot on their own, you pick upgrades
        after each wave, spend coins on levels and unlock new heroes. Every few waves a boss shows up. Lost the base?
        Upgrade and go again. While you are away the base keeps earning, so there is always something to collect.`,
    `Зомби лезут на штаб со всех сторон, волна за волной. Герои стреляют сами, а вы после каждой волны выбираете
        усиление, тратите монеты на уровни и открываете новых героев. Время от времени приходит босс. Штаб пал? Прокачайтесь
        и снова в бой. Пока вас нет, база копит добычу, так что вернуться всегда есть за чем.`,
  ],
  ['aria-label="Game field"', 'aria-label="Игровое поле"'],
];

const UK_PAGE: PageStrings = [
  ['<html lang="en">', '<html lang="uk">'],
  [PAGE_META.en.title, PAGE_META.uk.title],
  [PAGE_META.en.description, PAGE_META.uk.description],
  ['rel="canonical" href="https://newfungame.com/"', 'rel="canonical" href="https://newfungame.com/uk"'],
  ['property="og:url" content="https://newfungame.com/"', 'property="og:url" content="https://newfungame.com/uk"'],
  ['property="og:locale" content="en_US"', 'property="og:locale" content="uk_UA"'],
  ["Zombie defense game: hold the base", "Зомбі-оборона: утримай штаб"],
  [
    `Zombies come at your base from every side, wave after wave. Your heroes shoot on their own, you pick upgrades
        after each wave, spend coins on levels and unlock new heroes. Every few waves a boss shows up. Lost the base?
        Upgrade and go again. While you are away the base keeps earning, so there is always something to collect.`,
    `Зомбі сунуть на штаб з усіх боків, хвиля за хвилею. Герої стріляють самі, а ви після кожної хвилі обираєте
        підсилення, витрачаєте монети на рівні й відкриваєте нових героїв. Час від часу приходить бос. Штаб упав? Прокачайтеся
        і знову в бій. Поки вас немає, база збирає здобич, тож повернутися завжди є заради чого.`,
  ],
  ['aria-label="Game field"', 'aria-label="Ігрове поле"'],
];

/** Страницы языков, которые собирает плагин в `vite.config.ts`. */
export const LOCALE_PAGES = { ru: RU_PAGE, uk: UK_PAGE } as const;

/** HTML страницы языка из собранного `index.html`. */
export function localePage(html: string, locale: keyof typeof LOCALE_PAGES): string {
  return LOCALE_PAGES[locale].reduce((page, [en, localized]) => {
    if (!page.includes(en)) throw new Error(`index.html: нет строки для /${locale}: ${en}`);
    return page.replaceAll(en, localized);
  }, html);
}
